<template>
  <div v-if="load && showContent">
    <v-skeleton-loader type="article"></v-skeleton-loader>
  </div>
  <div v-else>
    <div v-if="showContent" style="position: relative;height: 100%;overflow: auto;min-height: 200px;">
      <div style="position: absolute; top: 0;">

        <div v-for="item in list" :key="item.id" style="padding: 10px;">
          <div class="news-title">
            <v-row style="margin: 0;">
              <v-col class="px-0"><v-avatar size="30" :image="item.userpictureurl"></v-avatar>
                <span>{{ item.userfullname }}</span></v-col>
              <v-col class="d-flex px-0 align-center justify-end">
                <span>{{ item.timemodified }}</span>
              </v-col>
            </v-row>
          </div>

          <p style="font-weight: bold;">
            <a target="_blank"
              :href="'https://www.procollege.ru/mod/forum/discuss.php?d=' + item.discussion + '#p' + item.id">
              {{ item.subject }}
            </a>
          </p>
          <div v-html="item.message" class="itemMessage"></div>

          <v-divider style="margin-bottom: 0;" class="border-opacity-100"></v-divider>
        </div>

      </div>
    </div>
    <div v-else class="cursor-pointer">
      <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-server"></v-icon>
      </v-col>

      <v-col style="word-break: break-word" class="d-flex flex-column align-center">
        <span>Новости ProCollege</span>
      </v-col>
    </div>

  </div>

</template>

<script>
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
    showContent: {
      default: false,
      type: Boolean
    }
  },
  name: "proCollegeNewsWidget",
  data() {
    return {
      list: [],
      load: false
    };
  },
  watch: {
    showContent: function (newVal) {
      if (newVal && this.list.length == 0) {
        this.loadData();
      }
    }
  },
  created() {
    if (!this.showContent) {
      return
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.load = true;
      //let host=this.$model.mainHost;
      let host = "https://www.procollege.ru";
      this.axios
        .post(
          host + "/procNewsExternal.php"
        )
        .then((response) => {
          this.list = response.data;
          this.load = false;
        })
        .catch((error) => {
          this.list = [
            {
              text_mess: "Не удалось подключиться к новостному серверу " + host,
              date_create: ""
            }
          ];
          this.load = false;
          console.log(error);
        });
    }
  },
};
</script>
<style lang="scss">
#procollege_desktop2 {
  .news-title {
    font-style: italic;
    color: #535d6c;
    font-size: 12px;
  }

  .itemMessage img {
    max-width: 100%;
    height: auto;
  }
}
</style>
